import React from "react";
import { Route, Routes } from "react-router-dom";

import usePageView from "../Utils/usePageView";
import { ForgotPasswordRoute } from "./UnProtectedRoutes/ForgotPasswordRoute";
export const UnProtectedRoutes = () => {
  usePageView();
  return (
    <Routes>
      <Route path="/forgot-password" element={<ForgotPasswordRoute />} />
    </Routes>
  );
};
